export const getContentLanguage = (contentData) => {
  const tagsData = contentData?.data?.post?.content?.tags;
  const language = ['en', 'bn', 'hi', 'te', 'ta'];
  const output = tagsData?.filter(function (obj) {
    return language.indexOf(obj) !== -1;
  });
  const selectedLanguage = output.length > 0 ? output[0] : 'en';
  return selectedLanguage;
};

export const getViewsText = (lang) => {
  switch (lang) {
    case 'hi':
      return 'व्यूज';
    case 'bn':
      return 'ভিউস';
    case 'ta':
      return 'காட்சிகள்';
    case 'te':
      return 'వీక్షణలు';
    default:
      return 'Views';
  }
};
